<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Filter by Units
            </mat-panel-title>
            <mat-panel-description>
                {{filters.unitIds.length}} units selected
            </mat-panel-description>
        </mat-expansion-panel-header>
        <lf-unit-selector [preselectedUnitIds]="filters.unitIds"
                          [isShowingBalances]="true"
                          [isShowingPastDue]="true"
                          (onSelect)="updateModel($event)"></lf-unit-selector>
    </mat-expansion-panel>
</mat-accordion>
